import { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";

import AuthPage from "./auth";
import FormChucVu from "./chucvu/FormChucVu";
import ListChucVu from "./chucvu/ListChucVu";
import FormCompany from "./cong-ty/FormCompany";
import ListCompany from "./cong-ty/ListCompany";
import CaiDatNgayChotCong from "./cong-ty/CaiDatNgayChotCong";
import CaiDatCong from "./cong-ty/CaiDatCong";
import Loading from "./component/Loading";
import DanhSachDuyetGiaiTrinh from "./giai-trinh/DanhSachPheDuyetGiaiTrinh";
import DanhSachGiaiTrinh from "./giai-trinh/DanhSachGiaiTrinh";
import TraCuuLichSu from "./tra-cuu-lich-su/TraCuuLichSu";
import CayNhanSu from "./cay-nhan-su/CayNhanSu";
import FormDuyetGiaiTrinh from "./giai-trinh/FormDuyetGiaiTrinh";
import FormGiaiTrinh from "./giai-trinh/FormGiaiTrinh";

import FormParts from "./phong-ban/FormParts";
import ListParts from "./phong-ban/ListParts";
import ProfilePage from "./profile";
import FormPasswordPage from "./profile/FormPassword";
import { actions } from "./redux/authRedux";
import FormRolesPage from "./phan-quyen/FormRoles";
import ListRolesPage from "./phan-quyen/ListRoles";
import FormSettings from "./settings/FormSettings";
import ListSettingsPage from "./settings/ListSettings";
import TestEmail from "./test-email/TestEmail";
import FormUsersPage from "./nhan-su/FormUsers";
import ListUsersPage from "./nhan-su/ListUsers";
import UploadUsers from "./nhan-su/UploadUsers";
import DanhSachDuyetXinNghi from "./xin-nghi/DanhSachDuyetXinNghi";
import FormDuyetXinNghi from "./xin-nghi/FormDuyetXinNghi";
import FormXinNghi from "./xin-nghi/FormXinNghi";
import DanhSachXinNghi from "./xin-nghi/DanhSachXinNghi";
import FormTimeSettings from "./bang-cham-cong/FormCaiDatChamCong";
import ListTimeSettings from "./bang-cham-cong/CaiDatChamCong";
import ListUsersOnday from "./bang-cham-cong/BangChamCongChiTiet";
import UploadUsersOnday from "./bang-cham-cong/UploadUsersOnday";
import BangChamCongThang from "./bang-cham-cong/BangChamCongThang";
import DanhSachGuiMail from "./test-email/DanhSachGuiMail";
import DanhSachCaLam from "./ca-lam/DanhSachCa";
import FormCa from "./ca-lam/FormCa";
import CaiDatNhanSu from "./nhan-su/CaiDatNhanSu";
import DanhSachNgayLe from "./nghi-le/DanhSachNgayLe";
import FormNgayLe from "./nghi-le/FormNgayLe";
import DanhSachDangKyOL from "./lam-online/DanhSachDangKyOL";
import FormDangKyLamOL from "./lam-online/FormDangKyLamOL";
import XuatBangChamCong from "./bang-cham-cong/XuatBangChamCong";
import ListUserCustimizer from "./nhan-su-tuy-bien/ListUserCustimizer";
import FormUserCustimizer from "./nhan-su-tuy-bien/FormUserCustimizer";
import XuatGiaiTrinhCong from "./giai-trinh/XuatGiaiTrinhCong";
import DangKyLamLe from "./lam-ngay-le/DangKyLamLe";
import FormDangKyLe from "./lam-ngay-le/FormDangKyLe";
import DanhSachDuyetDangKyLe from "./lam-ngay-le/DanhSachDuyetDangKyLe";
import FormDuyetDangKyLe from "./lam-ngay-le/FormDuyetDangKyLe";
import DanhMucTin from "./tin-tuc/DanhMucTin";
import FormDanhMucTin from "./tin-tuc/FormDanhMucTin";
import TinTuc from "./tin-tuc/TinTuc";
import FormTinTuc from "./tin-tuc/FormTinTuc";
import XemTin from "./tin-tuc/XemTin";
import LayMatKhau from "./bang-tin/LayMatKhau";
import DoiMatKhau from "./bang-tin/DoiMatKhau";
import UploadChamCongBPMAX from "./bang-cham-cong/UploadChamCongBPMAX";
import LoginSSO from "./auth/LoginSSO";
import XuatNhanSu from "./nhan-su/XuatNhanSu";
import QuanLyCa from "./ca-lam-viec/QuanLyCa";
import FormQuanLyCa from "./ca-lam-viec/FormQuanLyCa";
import PhanCaLam from "./ca-lam-viec/PhanCaLam";
import FormPhanCa from "./ca-lam-viec/FormPhanCa";
import DanhSachThucTapSinh from "./nhan-su/DanhSachThucTapSinh";
import FormTTS from "./nhan-su/FormTTS";
import ChotCongThang from "./bang-cham-cong/ChotCongThang";
import BangChotCongThang from "./bang-cham-cong/BangChotCongThang";

import ListUsersLogin from "./nhan-su/ListUsersLogin";
import ListUserVote from "./users-vote/ListUserVote";
import ViewEmail from "./test-email/ViewEmail";
import DanhSachLoaiHopDong from "./hop-dong/DanhSachLoaiHopDong";
import FormLoaiHopDong from "./hop-dong/FormLoaiHopDong";
import XuatDangKyCong from "./xin-nghi/XuatDangKyCong";

import DanhSachLog from "./logs/DanhSachLog";
import SuaBangChamCongChiTiet from "./bang-cham-cong/SuaBangChamCongChiTiet";
import SuaBangChotCongThang from "./bang-cham-cong/SuaBangChotCongThang";
import DanhSachHopDong from "./hop-dong/DanhSachHopDong";
import FormHopDong from "./hop-dong/FormHopDong";
import HuongDanSuDungHopDong from "./hop-dong/HuongDanSuDung";
import ImportHopDong from "./hop-dong/ImportHopDong";
import BaoCaoCongViec from "./baocaocongviec/BaoCaoCongViec";
import DanhSachNgayLamBu from "./lam-bu/DanhSachNgayLamBu";
import FormLamBu from "./lam-bu/FormLamBu";
import DanhSachVanThu from "./van-thu-luu-tru/DanhSachVanThu";
import FormVanThu from "./van-thu-luu-tru/FormVanThu";
import DanhSachLoaiVanThu from "./van-thu-luu-tru/DanhSachLoaiVanThu";
import FormLoaiVanThu from "./van-thu-luu-tru/FormLoaiVanThu";
import DanhSachUngVien from "./nhan-su/DanhSachUngVien";
import FormUngVien from "./nhan-su/FormUngVien";
import ListUsersGitiho from "./users_gitiho/ListUsersGitiho";
import FormUsersGitiho from "./users_gitiho/FormUsersGitiho";
import PhanCongCapSo from "./van-thu-luu-tru/PhanCongCapSo";
import FormPhanCongCapSo from "./van-thu-luu-tru/FormPhanCongCapSo";
import ListQRCode from "./dich-vu-cong-nghe/ListQRCode";
import FormQrcode from "./dich-vu-cong-nghe/FormQrcode";
import ViewPdfBook from "./dich-vu-cong-nghe/ViewPdfBook";
import DanhSachXe from "./dat-xe-phong-hop/DanhSachXe";
import FormCars from "./dat-xe-phong-hop/FormCars";
import DanhSachDatXe from "./dat-xe-phong-hop/DanhSachDatXe";
import FormDatXe from "./dat-xe-phong-hop/FormDatXe";
import DanhSachPhongHop from "./dat-xe-phong-hop/DanhSachPhongHop";
import DanhSachDatPhongHop from "./dat-xe-phong-hop/DanhSachDatPhongHop";
import FormRooms from "./dat-xe-phong-hop/FormRooms";
import DanhSachDiaDiem from "./dat-cho-ngoi/DanhSachDiaDiem";
import FormDiaDiem from "./dat-cho-ngoi/FormDiaDiem";
import DatChoNgoi from "./dat-cho-ngoi/DatChoNgoi";
import CheckinQR from "./dat-cho-ngoi/CheckinQR";
import DanhSachMayChamCong from "./dich-vu-cong-nghe/DanhSachMayChamCong";
import FormMayChamCong from "./dich-vu-cong-nghe/FormMayChamCong";
import XuatUngVien from "./nhan-su/XuatUngVien";
import DanhSachSticker from "./sticker/DanhSachSticker";
import FormSticker from "./sticker/FormSticker";
import DanhSachLinkUV from "./nhan-su/DanhSachLinkUV";
import FormLinkUV from "./nhan-su/FormLinkUV";
import BangTin from "./bang-tin/BangTin";
import ListCalendar from "./calendar/ListCalendar";
import FormCalendar from "./calendar/FormCalendar";
import BaoCaoXePhongHop from "./bao-cao/BaoCaoXePhongHop";
import BaoCaoNhanSu from "./bao-cao/BaoCaoNhanSu";
import NotFound from "./NotFound";
import DanhSachCheckin from "./dich-vu-cong-nghe/checkin/DanhSachCheckin";
import FormCheckin from "./dich-vu-cong-nghe/checkin/FormCheckin";
import UserCheckin from "./dich-vu-cong-nghe/checkin/UserCheckin";
import TheoDoiCheckIn from "./dich-vu-cong-nghe/checkin/TheoDoiCheckIn";
import ExportVanThu from "./van-thu-luu-tru/ExportVanThu";
import HuongDanVanThu from "./van-thu-luu-tru/HuongDanVanThu";
import ChiTietTin from "./bang-tin/ChiTietTin";
import ListCapBac from "./chucvu/ListCapBac";
import FormCapBac from "./chucvu/FormCapBac";
import ListForm from "./blue-form/ListForm";
import FormBuilderPage from "./blue-form/FormBuilderPage";
import DanhSachTanTuyen from "./tan-tuyen/DanhSachTanTuyen";
import FormTanTuyen from "./tan-tuyen/FormTanTuyen";
import DanhSachPhanLoai from "./workflows/DanhSachPhanLoai";
import FormPhanLoai from "./workflows/FormPhanLoai";
import { FormToTrinhV2, DanhSachToTrinhV2, XemToTrinhV2 } from "./trinh-ky";
import HuongDanToTrinh from "./trinh-ky/HuongDanToTrinh";
import DanhSachQuanLyProfile from "./LearningHub/DanhSachQuanLyProfile";
import FormProfile from "./LearningHub/FormProfile";
import DanhSachProfile from "./LearningHub/DanhSachProfile";
import DanhSachQuanLyBaiGiang from "./LearningHub/DanhSachQuanLyBaiGiang";
import FormBaiGiang from "./LearningHub/FormBaiGiang";
import FormBaiGiangPage from "./LearningHub/FormBaiGiangPage";
import DanhSachKhoaHoc from "./LearningHub/DanhSachKhoaHoc";
import DanhSachBaiHoc from "./LearningHub/DanhSachBaiHoc";
import BaiHocChiTiet from "./LearningHub/BaiHocChiTiet";
import DanhSachCauHoi from "./LearningHub/DanhSachCauHoi";
import FormCauHoi from "./LearningHub/FormCauHoi";
import DanhSachDeThi from "./LearningHub/DanhSachDeThi";
import FormDeThi from "./LearningHub/FormDeThi";
import LamBaiThi from "./LearningHub/LamBaiThi";
import BaiKiemTraCuaToi from "./LearningHub/BaiKiemTraCuaToi";
import TheoDoiLamBai from "./LearningHub/TheoDoiLamBai";
import HuongDanLearningAdmin from "./LearningHub/HuongDanLearningAdmin";
import HuongDanLearningHocSinh from "./LearningHub/HuongDanLearningHocSinh";
import KetQuaBaiLam from "./LearningHub/KetQuaBaiLam";
import DanhSachBaiLam from "./LearningHub/DanhSachBaiLam";
import ChamBaiLam from "./LearningHub/ChamBaiLam";
import DanhSachCTVSale from "./nhan-su/DanhSachCTVSale";
import FormUsersCTV from "./nhan-su/FormUsersCTV";
import DanhSachNCC from "./mua-sam/DanhSachNCC";
import FormNCC from "./mua-sam/FormNCC";
import DanhSachMuaSam from "./mua-sam/DanhSachMuaSam";
import FormMuaSam from "./mua-sam/FormMuaSam";
import DanhSachCheDo from "./nghi-che-do/DanhSachCheDo";
import FormNghiCheDo from "./nghi-che-do/FormNghiCheDo";
import DanhSachNghiepVu from "./cong-viec/DanhSachNghiepVu";
import FormNghiepVu from "./cong-viec/FormNghiepVu";
import DanhSachCongViec from "./cong-viec/DanhSachCongViec";
import FormCongViec from "./cong-viec/FormCongViec";
import NhanSuNghiNhieu from "./nhan-su/NhanSuNghiNhieu";
import NgayPhep from "./nhan-su/NgayPhep";
import ChucMungSinhNhatBHS from "./chuc-mung-sinh-nhat-bhs";
import UpdateNhanSu from "./nhan-su/UpdateNhanSu";

function App(props) {
  const { user } = useSelector((state) => state.auth);
  const isAuthorized = user != null;
  // Mốc coi token là "sắp hết hạn" để kích hoạt refresh sớm.
  //
  // Trước đây cộng cứng 1 giờ, hợp lý khi access token sống 365 ngày. Từ 03/11/2026
  // access token chỉ còn 1 giờ, nên nếu giữ nguyên thì điều kiện (user.expires > now)
  // LUÔN sai ngay khi vừa đăng nhập -> người dùng kẹt màn chờ xoay vĩnh viễn.
  //
  // Nay refresh sớm 5 phút trước khi hết hạn: đủ để gọi /refresh xong trước khi
  // token chết, mà vẫn dùng gần trọn vòng đời token.
  const BIEN_REFRESH_SOM = 5 * 60; // giây
  // Nhịp đếm để component tự render lại theo thời gian. Không có nó, `now` chỉ được
  // tính đúng MỘT LẦN lúc render: tab mở suốt buổi sẽ không bao giờ nhận ra token
  // sắp hết hạn, tới lúc thao tác thì token đã chết và request đầu tiên văng lỗi.
  const [nhipKiemTra, setNhipKiemTra] = useState(0);
  useEffect(() => {
    const dongHo = setInterval(() => setNhipKiemTra((n) => n + 1), 60 * 1000);
    return () => clearInterval(dongHo);
  }, []);
  // eslint-disable-next-line no-unused-vars
  const _nhip = nhipKiemTra; // chỉ để React render lại mỗi phút
  const now = parseInt(new Date().getTime() / 1000) + BIEN_REFRESH_SOM;
  const dispatch = useDispatch();
  // const crurl = window.location.href
  useEffect(function () {
    //  dispatch(actions.login(null));
    let web_url = window.location.hostname
    let pathname = window.location.pathname

    if (web_url === 'hr.bhsgroup.vn') window.location.href = 'https://noibo.bhsgroup.vn' + pathname
    if (isAuthorized && !user.data.roles) dispatch(actions.login(null));
  }, [dispatch, user, isAuthorized])

  const resizeObserverLoopError = e => {
    if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
      e.stopImmediatePropagation();
    }
  };
  window.addEventListener('error', resizeObserverLoopError);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  return (
    <BrowserRouter basename={""}>
      <Suspense fallback={<Loading color="secondary" />} >
        <Switch>
          {/* <Route path="/">
            <Baotri />
          </Route> */}
          <Route path="/auth">
            <AuthPage></AuthPage>
          </Route>
          <Route path="/login-sso"><LoginSSO /></Route>
          <Route exact path="/chuc-mung-sinh-nhat-bhs"><ChucMungSinhNhatBHS /></Route>
          {!isAuthorized ?
            //console.log(encodeURI(crurl))
            <Redirect to="/auth/login" />
            // <Redirect to={crurl !== 'http://localhost:3000/' || crurl !== 'https://hr.bhsgroup.vn/' ? "/auth/login?redirect="+encodeURI(crurl) : "/auth/login"} />
            :
            <>
              {user.expires > now ? <>
                <Route exact path="/"><Redirect to="/bang-tin" /></Route>
                <Route exact path="/dashboard"><Redirect to="/bang-tin" /></Route>

                <Route exact path="/bang-tin"><BangTin /></Route>
                <Route exact path="/bang-tin/:id"><ChiTietTin /></Route>
                <Route path="/bang-tin/danh-muc/:alias"><BangTin /></Route>

                <Route path="/list-roles"><ListRolesPage></ListRolesPage></Route>
                <Route path="/edit-roles/:id"><FormRolesPage></FormRolesPage></Route>
                <Route path="/add-roles"><FormRolesPage></FormRolesPage></Route>

                <Route path="/baocaocongviec"><BaoCaoCongViec></BaoCaoCongViec></Route>

                <Route path="/list-users"><ListUsersPage></ListUsersPage></Route>
                <Route path="/edit-users/:id"><FormUsersPage></FormUsersPage></Route>
                <Route path="/add-users"><FormUsersPage></FormUsersPage></Route>
                <Route path="/upload-users"><UploadUsers></UploadUsers></Route>
                <Route path="/export-users"><XuatNhanSu /></Route>
                <Route path="/list-thuc-tap-sinh"><DanhSachThucTapSinh /></Route>
                <Route path="/edit-thuc-tap-sinh/:id"><FormTTS /></Route>
                <Route path="/add-thuc-tap-sinh"><FormTTS /></Route>
                <Route path="/users_login"><ListUsersLogin /></Route>
                <Route path="/update-nhan-su"><UpdateNhanSu /></Route>
                <Route path="/quan-ly-phep"><NgayPhep /></Route>

                <Route path="/users_new"><DanhSachUngVien /></Route>
                <Route path="/add-users_new"><FormUngVien /></Route>
                <Route path="/edit-users_new/:id"><FormUngVien /></Route>
                <Route path="/export-users_new"><XuatUngVien /></Route>

                <Route path="/users_ctv"><DanhSachCTVSale /></Route>
                <Route path="/add-users_ctv"><FormUsersCTV /></Route>
                <Route path="/edit-users_ctv/:id"><FormUsersCTV /></Route>

                <Route path="/users_vote"><ListUserVote /></Route>

                <Route path="/users_gitiho"><ListUsersGitiho /></Route>
                <Route path="/add-users_gitiho"><FormUsersGitiho /></Route>
                <Route path="/edit-users_gitiho/:id"><FormUsersGitiho /></Route>


                <Route path="/list-users_onday"><ListUsersOnday /></Route>
                <Route path="/edit-users_onday/:id"><SuaBangChamCongChiTiet /></Route>
                <Route path="/list-cham-cong-thang"><BangChamCongThang /></Route>
                <Route path="/upload-users_onday"><UploadUsersOnday /></Route>
                <Route path="/upload-chamcong-bpmax"><UploadChamCongBPMAX /></Route>
                <Route path="/list-users_onday_settings"><ListTimeSettings /></Route>
                <Route path="/add-users_onday_settings"><FormTimeSettings /></Route>
                <Route path="/edit-users_onday_settings/:id"><FormTimeSettings /></Route>

                <Route path="/export-bang-cham-cong-thang"><XuatBangChamCong /></Route>
                <Route path="/chotbangchamcong"><ChotCongThang /></Route>
                <Route path="/bangchotcongthang"><BangChotCongThang /></Route>
                <Route path="/edit-bangchotcongthang/:id"><SuaBangChotCongThang /></Route>

                <Route path="/list-chucvu"><ListChucVu></ListChucVu></Route>
                <Route path="/add-chucvu"><FormChucVu></FormChucVu></Route>
                <Route path="/edit-chucvu/:id"><FormChucVu></FormChucVu></Route>

                <Route path="/capbac"><ListCapBac></ListCapBac></Route>
                <Route path="/add-capbac"><FormCapBac></FormCapBac></Route>
                <Route path="/edit-capbac/:id"><FormCapBac></FormCapBac></Route>

                <Route path="/blue-form"><ListForm /></Route>
                <Route path="/add-blue_forms"><FormBuilderPage /></Route>
                <Route path="/edit-blue_forms/:id"><FormBuilderPage /></Route>

                <Route path="/list-parts"><ListParts></ListParts></Route>
                <Route path="/add-parts"><FormParts></FormParts></Route>
                <Route path="/edit-parts/:id"><FormParts></FormParts></Route>

                <Route path="/list-company"><ListCompany /></Route>
                <Route path="/cai-dat-ngay-chot-cong"><CaiDatNgayChotCong /></Route>
                <Route path="/cai-dat-cong"><CaiDatCong /></Route>
                <Route path="/add-company"><FormCompany /></Route>
                <Route path="/edit-company/:id"><FormCompany /></Route>

                <Route path="/my-profile"><ProfilePage /></Route>
                {/* <Route path="/update-profile"><FormProfilePage /></Route> */}
                <Route path="/change-password"><FormPasswordPage /></Route>

                <Route path="/list-settings"><ListSettingsPage /></Route>
                <Route path="/add-settings"><FormSettings /></Route>
                <Route path="/edit-settings/:id"><FormSettings /></Route>

                <Route path="/list-users-break"><DanhSachXinNghi /></Route>
                <Route path="/add-users-break"><FormXinNghi /></Route>
                <Route path="/edit-users-break/:id"><FormXinNghi /></Route>
                <Route path="/view-users-break/:id"><FormXinNghi /></Route>
                <Route path="/export-users-break"><XuatDangKyCong /></Route>

                <Route path="/list-approve-break"><DanhSachDuyetXinNghi /></Route>
                <Route path="/view-users-break/:id"><FormDuyetXinNghi /></Route>
                <Route path="/approve-users-break/:id"><FormDuyetXinNghi /></Route>

                <Route path="/list-giaitrinh"><DanhSachGiaiTrinh /></Route>
                <Route path="/tra-cuu-lich-su"><TraCuuLichSu /></Route>
                <Route path="/cay-nhan-su"><CayNhanSu /></Route>
                <Route path="/add-giaitrinh"><FormGiaiTrinh /></Route>
                <Route path="/edit-giaitrinh/:id"><FormGiaiTrinh /></Route>
                <Route path="/export-giaitrinh"><XuatGiaiTrinhCong /></Route>

                <Route path="/list-duyet-giai-trinh"><DanhSachDuyetGiaiTrinh /></Route>
                <Route path="/approve-duyet-giai-trinh/:id"><FormDuyetGiaiTrinh /></Route>

                <Route path="/test-email"><TestEmail /></Route>
                <Route path="/danh-sach-gui-mail"><DanhSachGuiMail /></Route>
                <Route path="/edit-sendmail/:id"><ViewEmail /></Route>

                <Route path="/logs"><DanhSachLog /></Route>

                <Route path="/list-ca-lam"><DanhSachCaLam /></Route>
                <Route path="/add-ca-lam"><FormCa /></Route>
                <Route path="/edit-ca-lam/:id"><FormCa /></Route>

                <Route path="/quan-ly-ca"><QuanLyCa /></Route>
                <Route path="/add-quan-ly-ca"><FormQuanLyCa /></Route>
                <Route path="/edit-quan-ly-ca/:id"><FormQuanLyCa /></Route>
                <Route path="/phan-ca-lam"><PhanCaLam /></Route>
                <Route path="/add-phan-ca-lam"><FormPhanCa /></Route>
                <Route path="/edit-phan-ca-lam/:id"><FormPhanCa /></Route>

                <Route path="/cai-dat-nhan-su"><CaiDatNhanSu /></Route>

                <Route path="/ngay-le"><DanhSachNgayLe /></Route>
                <Route path="/add-ngay-le"><FormNgayLe /></Route>
                <Route path="/edit-ngay-le/:id"><FormNgayLe /></Route>

                <Route path="/danh-sach-dang-ky-lam-online"><DanhSachDangKyOL /></Route>
                <Route path="/add-dang-ky-lam-online"><FormDangKyLamOL /></Route>
                <Route path="/add-dang-ky-lam-online/:id"><FormDangKyLamOL /></Route>

                <Route path="/users-customizer"><ListUserCustimizer /></Route>
                <Route path="/add-users-customizer"><FormUserCustimizer /></Route>
                <Route path="/edit-users-customizer/:id"><FormUserCustimizer /></Route>

                <Route path="/dang-ky-lam-le"><DangKyLamLe /></Route>
                <Route path="/add-dang-ky-lam-le"><FormDangKyLe /></Route>
                <Route path="/edit-dang-ky-lam-le/:id"><FormDangKyLe /></Route>
                <Route path="/duyet-dang-ky-lam-le"><DanhSachDuyetDangKyLe /></Route>
                <Route path="/approve-dang-ky-lam-le/:id"><FormDuyetDangKyLe /></Route>

                <Route path="/danh-muc-tin"><DanhMucTin /></Route>
                <Route path="/edit-danh-muc-tin/:id"><FormDanhMucTin /></Route>
                <Route path="/add-danh-muc-tin"><FormDanhMucTin /></Route>

                <Route path="/danh-sach-tin"><TinTuc /></Route>
                <Route path="/add-danh-sach-tin"><FormTinTuc /></Route>
                <Route path="/edit-danh-sach-tin/:id"><FormTinTuc /></Route>

                <Route path="/mau-hop-dong"><DanhSachLoaiHopDong /></Route>
                <Route path="/hop-dong"><DanhSachHopDong /></Route>
                <Route path="/upload-hop-dong"><ImportHopDong /></Route>
                <Route path="/huong-dan-hop-dong"><HuongDanSuDungHopDong /></Route>
                <Route path="/add-hop-dong"><FormHopDong /></Route>
                <Route path="/edit-hop-dong/:id"><FormHopDong /></Route>
                <Route path="/add-mau-hop-dong"><FormLoaiHopDong /></Route>
                <Route path="/edit-mau-hop-dong/:id"><FormLoaiHopDong /></Route>

                <Route path="/quy-trinh-noi-bo/:id"><XemTin /></Route>

                <Route path="/lay-mat-khau"><LayMatKhau /></Route>
                <Route path="/doi-mat-khau"><DoiMatKhau /></Route>

                <Route path="/lambu"><DanhSachNgayLamBu /></Route>
                <Route path="/add-lambu"><FormLamBu /></Route>
                <Route path="/edit-lambu/:id"><FormLamBu /></Route>

                <Route path="/van-thu"><DanhSachVanThu /></Route>
                <Route path="/add-van-thu"><FormVanThu /></Route>
                <Route path="/export-van-thu"><ExportVanThu /></Route>
                <Route path="/edit-van-thu/:id"><FormVanThu /></Route>

                <Route path="/vanthu_param"><DanhSachLoaiVanThu /></Route>
                <Route path="/add-vanthu_param"><FormLoaiVanThu /></Route>
                <Route path="/edit-vanthu_param/:id"><FormLoaiVanThu /></Route>
                <Route path="/huong-dan-van-thu"><HuongDanVanThu /></Route>
                <Route path="/phan-cong-cap-so"><PhanCongCapSo /></Route>
                <Route path="/add-phan-cong-cap-so"><FormPhanCongCapSo /></Route>
                <Route path="/edit-phan-cong-cap-so/:id"><FormPhanCongCapSo /></Route>

                <Route path="/quan-ly-qrcode"><ListQRCode /></Route>
                <Route path="/add-quan-ly-qrcode"><FormQrcode /></Route>
                <Route path="/edit-quan-ly-qrcode/:id"><FormQrcode /></Route>

                <Route path="/view-pdf"><ViewPdfBook /></Route>

                <Route path="/quan-ly-xe"><DanhSachXe /></Route>
                <Route path="/add-cars"><FormCars /></Route>
                <Route path="/edit-cars/:id"><FormCars /></Route>

                <Route path="/dat-xe"><DanhSachDatXe /></Route>
                <Route path="/add-car-booking"><FormDatXe /></Route>
                <Route path="/edit-car-booking/:id"><FormDatXe /></Route>

                <Route path="/dat-phong-hop"><DanhSachDatPhongHop /></Route>
                <Route path="/quan-ly-phong-hop"><DanhSachPhongHop /></Route>
                <Route path="/add-rooms"><FormRooms /></Route>
                <Route path="/edit-rooms/:id"><FormRooms /></Route>

                {/* Đặt chỗ ngồi làm việc */}
                <Route path="/dia-diem-cho-ngoi"><DanhSachDiaDiem /></Route>
                <Route path="/add-dia-diem-cho-ngoi"><FormDiaDiem /></Route>
                <Route path="/edit-dia-diem-cho-ngoi/:id"><FormDiaDiem /></Route>
                <Route path="/dat-cho-ngoi"><DatChoNgoi /></Route>
                <Route path="/checkin-cho-ngoi"><CheckinQR /></Route>

                <Route path="/bao-cao-xe-phong-hop"><BaoCaoXePhongHop /></Route>
                <Route path="/bao-cao-nhan-su"><BaoCaoNhanSu /></Route>


                <Route path="/may-cham-cong"><DanhSachMayChamCong /></Route>
                <Route path="/add-may-cham-cong"><FormMayChamCong /></Route>
                <Route path="/edit-may-cham-cong/:id"><FormMayChamCong /></Route>

                <Route path="/quan-ly-sticker"><DanhSachSticker /></Route>
                <Route path="/add-posts_sticker"><FormSticker /></Route>
                <Route path="/edit-posts_sticker/:id"><FormSticker /></Route>

                <Route path="/link-ung-vien"><DanhSachLinkUV /></Route>
                <Route path="/add-link_ungvien"><FormLinkUV /></Route>
                <Route path="/edit-link_ungvien/:id"><FormLinkUV /></Route>

                <Route path="/calendar"><ListCalendar /></Route>
                <Route path="/add-calendar"><FormCalendar /></Route>
                <Route path="/edit-calendar/:id"><FormCalendar /></Route>

                <Route path="/tan-tuyen"><DanhSachTanTuyen /></Route>
                <Route path="/add-users_tdd"><FormTanTuyen /></Route>
                <Route path="/edit-users_tdd/:id"><FormTanTuyen /></Route>

                <Route path="/checkin"><DanhSachCheckin /></Route>
                <Route path="/add-checkin"><FormCheckin /></Route>
                <Route path="/edit-checkin/:id"><FormCheckin /></Route>
                <Route path="/user_checkin/:id"><UserCheckin /></Route>
                <Route path="/theo-doi-checkin/:id"><TheoDoiCheckIn /></Route>

                <Route path="/workflow_type"><DanhSachPhanLoai /></Route>
                <Route path="/add-workflow_type"><FormPhanLoai /></Route>
                <Route path="/edit-workflow_type/:id"><FormPhanLoai /></Route>

                {/* Trình ký V2 chạy trên URL cũ của V1 — giữ nguyên menu/thông báo/bookmark */}
                <Route path="/workflow_walking"><DanhSachToTrinhV2 /></Route>
                <Route path="/add-workflow_walking"><FormToTrinhV2 /></Route>
                <Route path="/edit-workflow_walking/:id"><FormToTrinhV2 /></Route>
                <Route path="/ho-so-truc-tuyen/:id"><XemToTrinhV2 /></Route>
                <Route path="/huong-dan-to-trinh"><HuongDanToTrinh /></Route>

                {/* Alias V2 (truy cập trực tiếp) */}
                <Route path="/tk_request"><DanhSachToTrinhV2 /></Route>
                <Route path="/add-tk_request"><FormToTrinhV2 /></Route>
                <Route path="/edit-tk_request/:id"><FormToTrinhV2 /></Route>


                <Route path="/learning_profile_manager"><DanhSachQuanLyProfile /></Route>
                <Route path="/add-learninghub_profiles"><FormProfile /></Route>
                <Route path="/edit-learninghub_profiles/:id"><FormProfile /></Route>

                <Route path="/learninghub-profile"><DanhSachProfile /></Route>
                <Route path="/khoa-hoc"><DanhSachKhoaHoc /></Route>
                <Route path="/khoa-hoc-chi-tiet/:id"><DanhSachBaiHoc /></Route>
                <Route path="/bai-hoc-chi-tiet/:id"><BaiHocChiTiet /></Route>

                <Route path="/learninghub_baigiang"><DanhSachQuanLyBaiGiang /></Route>
                <Route path="/add-learninghub_baigiang"><FormBaiGiang /></Route>
                <Route path="/edit-learninghub_baigiang/:id"><FormBaiGiang /></Route>
                <Route path="/edit-learninghub_baigiang_pages/:id"><FormBaiGiangPage /></Route>

                <Route path="/learninghub_cauhoi"><DanhSachCauHoi /></Route>
                <Route path="/add-learninghub_cauhoi"><FormCauHoi /></Route>
                <Route path="/edit-learninghub_cauhoi/:id"><FormCauHoi /></Route>

                <Route path="/learninghub_dethi"><DanhSachDeThi /></Route>
                <Route path="/add-learninghub_dethi"><FormDeThi /></Route>
                <Route path="/edit-learninghub_dethi/:id"><FormDeThi /></Route>

                <Route path="/bai-kiem-tra"><BaiKiemTraCuaToi /></Route>
                <Route path="/theo-doi-lam-bai/:id"><TheoDoiLamBai /></Route>
                <Route path="/huong-dan-learning-admin"><HuongDanLearningAdmin /></Route>
                <Route path="/huong-dan-learning-hoc-sinh"><HuongDanLearningHocSinh /></Route>
                <Route path="/lam-bai-thi/:id"><LamBaiThi /></Route>
                <Route path="/ket-qua-bai-lam/:id"><KetQuaBaiLam /></Route>
                <Route path="/learninghub_bailam"><DanhSachBaiLam /></Route>
                <Route path="/cham-bai-lam/:id"><ChamBaiLam /></Route>

                <Route path="/purchasing_supplier"><DanhSachNCC /></Route>
                <Route path="/add-purchasing_supplier"><FormNCC /></Route>
                <Route path="/edit-purchasing_supplier/:id"><FormNCC /></Route>

                <Route path="/purchasing_walking"><DanhSachMuaSam /></Route>
                <Route path="/add-purchasing_walking"><FormMuaSam /></Route>
                <Route path="/edit-purchasing_walking/:id"><FormMuaSam /></Route>

                <Route path="/che-do"><DanhSachCheDo /></Route>
                <Route path="/add-che-do"><FormNghiCheDo /></Route>
                <Route path="/edit-che-do/:id"><FormNghiCheDo /></Route>

                 <Route path="/works_mission"><DanhSachNghiepVu /></Route>
                 <Route path="/add-works_mission"><FormNghiepVu /></Route>
                 <Route path="/edit-works_mission/:id"><FormNghiepVu /></Route>

                 <Route path="/works_order"><DanhSachCongViec /></Route>
                 <Route path="/add-works_order"><FormCongViec /></Route>
                 <Route path="/edit-works_order/:id"><FormCongViec /></Route>

                 <Route path="/users_leave"><NhanSuNghiNhieu /></Route>

                {/* <Route path="*"><NotFound /></Route> */}
              </> : <Loading color="secondary" expire={user.expires <= now} />}
            </>
          }

        </Switch>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
